const disableSearchShortcutEvent = (disable: boolean) =>
  new CustomEvent('searchShortcutDisabledEvent', {
    detail: {
      disable,
    },
  });

export const dispatchDisableSearchShortcutEvent = (disable: boolean) => {
  window.dispatchEvent(disableSearchShortcutEvent(disable));
};
